export const pluginName = "activity-history";
